import { useRef, useState } from "react";
import UserManagementActions from "../../Actions/UserManagementActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const DisableEnableUser = (props) => {
  const { userId } = props;
  const [reason, setReason] = useState("");
  const blockModal = useRef();
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const blockUser = (e) => {
    e.preventDefault();
    const blockData = {
      userId: userId,
      reason: reason,
    };
    setGlobalSpinner(true);
    UserManagementActions.blockUser(blockData);
  };

  return (
    <div
      className="modal fade"
      id="blockModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="blockModalLabel"
      aria-hidden="true"
      ref={blockModal}
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="blockModalLabel">
              {localization.blockUser}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="blockModalClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form id="blockOrgForm" onSubmit={blockUser}>
              <div className="form-group">
                <textarea
                  className="form-control"
                  placeholder={localization.blockingReason}
                  required
                  id="blockReason"
                  name="blockReason"
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                ></textarea>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary">
                  {localization.save}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisableEnableUser;
